import styled from 'styled-components'

export const AutoPopulate = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  border-radius: 0.688rem;
  margin: 1.75rem 0;
  padding: 2.875rem 1.75rem;
`
